var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99665 0.714355H17.8538C18.2327 0.714355 18.5961 0.864865 18.8639 1.13277C19.1318 1.40068 19.2824 1.76404 19.2824 2.14293V15.0001M7.8538 8.5715V15.7144M11.4252 12.1429H4.28237M13.5681 5.00007H2.13951C1.35053 5.00007 0.710938 5.63967 0.710938 6.42864V17.8572C0.710938 18.6462 1.35053 19.2858 2.13951 19.2858H13.5681C14.3571 19.2858 14.9967 18.6462 14.9967 17.8572V6.42864C14.9967 5.63967 14.3571 5.00007 13.5681 5.00007Z",
    stroke: "#AA1A5F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicateIcon.cb746596f463cc9349655f9b1474cdb2.svg";
export { ForwardRef as ReactComponent };